import React, { Component } from 'react';

import classNames from 'classnames';
import { ButtonIcon } from 'components/button';
import { Input } from 'components/input';
import { Loader } from 'components/loader';
import DeleteModal from 'components/modal/DeleteModal';
import { I18n } from 'components/translate';
import { isKeyDownEnter, isKeyDownEsc } from 'helpers/Event';
import { inject, observer } from 'mobx-react';
import { UserSegmentationService } from 'modules/userManager';
import PropTypes from 'prop-types';

import './UserSegmentation.scss';

@inject((stores) => ({
  deleteLoading: stores.UserSegmentationStore.deleteLoading,
  renameDone: stores.UserSegmentationStore.renameDone,
  renameLoading: stores.UserSegmentationStore.renameLoading
}))
@observer
class UserSegmentation extends Component {
  // #region set up
  static propTypes = {
    deleteLoading: PropTypes.bool,
    renameDone: PropTypes.bool,
    renameLoading: PropTypes.bool,
    segmentation: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.state = {
      id: null,
      initialName: props.segmentation.name,
      modeEdit: false,
      name: props.segmentation.name,
      showDeleteModal: false
    };

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onRename = this.onRename.bind(this);
    this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
    this.toggleEdit = this.toggleEdit.bind(this);
  }

  componentDidUpdate() {
    const { id, name } = this.props.segmentation;
    const segmentationChanged = id !== this.state.id;

    if (segmentationChanged) {
      this.setState({ id, initialName: name, name });
    }
  }
  // #endregion

  // #region actions
  async onRename(name) {
    try {
      await UserSegmentationService.rename(name);

      this.setState({ name, initialName: name, modeEdit: false });
    } catch {
      this.resetRename();
    }
  }

  async onDelete() {
    try {
      await UserSegmentationService.delete(this.props.segmentation.id);
      await UserSegmentationService.getSegmentations();

      await UserSegmentationService.setSegmentationByIndex(0);
      UserSegmentationService.performSearch({ showLoading: false });
      // eslint-disable-next-line no-empty
    } catch {}

    this.toggleDeleteModal();
  }
  // #endregion

  // #region handlers
  toggleEdit() {
    this.setState(
      (prevState) => ({ modeEdit: !prevState.modeEdit }),
      () => {
        this.state.modeEdit && this._input && this._input.focus();
      }
    );
  }

  toggleDeleteModal = () => {
    this.setState((prevState) => ({
      showDeleteModal: !prevState.showDeleteModal
    }));
  };

  onBlur(e) {
    this.onRename(e.target.value);
  }

  onChange(e) {
    this.setState({ name: e.target.value });
  }

  handleKeyDown(e) {
    if (isKeyDownEnter(e)) {
      this.onRename(e.target.value);
    } else if (isKeyDownEsc(e)) {
      this.resetRename();
    }
  }

  resetRename() {
    this.setState({ modeEdit: false, name: this.state.initialName });
  }
  // #endregion

  // #region render
  render() {
    const { modeEdit, showDeleteModal } = this.state;
    const { deleteLoading, renameLoading, renameDone, segmentation } =
      this.props;
    const showIcon = renameLoading || renameDone;

    const iconClass = classNames('icon', {
      'icon-processing': renameLoading,
      'icon-check': renameDone
    });

    return (
      <div className="user__segmentation">
        <h2 className="user__segmentation__title__container">
          {modeEdit ? (
            this.renderTitleEdit()
          ) : (
            <div
              className="user__segmentation__title--text"
              onClick={this.toggleEdit}
            >
              {segmentation.name}
            </div>
          )}

          {showIcon && <i className={iconClass} />}
        </h2>

        <ButtonIcon
          size="small"
          transparent
          icon="delete"
          onClick={this.toggleDeleteModal}
        >
          <I18n label="general.exclude" />
        </ButtonIcon>

        {deleteLoading && <Loader key="loader" mask />}

        {showDeleteModal && (
          <DeleteModal
            isOpen
            title={
              <I18n label="users_manager.segmentation.delete_segmentation" />
            }
            description={
              <I18n label="general.delete_content_module_description" />
            }
            onConfirm={this.onDelete}
            onCancel={this.toggleDeleteModal}
          />
        )}
      </div>
    );
  }

  renderTitleEdit() {
    return (
      <Input
        autoComplete="off"
        className="user__segmentation__title--input"
        handleKeyDown={this.handleKeyDown}
        maxLength="50"
        name="name"
        onBlur={this.onBlur}
        onChange={this.onChange}
        placeholder="config_manager.config_data.area_name_placeholder"
        ref={(node) => (this._input = node)}
        type="text"
        value={this.state.name}
      />
    );
  }
  // #endregion
}

export default UserSegmentation;
